// Persistência do refresh token no browser.
//
// Débito conhecido (F13): trocar por httpOnly cookie emitido pelo backend
// para mitigar XSS. Até lá, CSP estrita em `index.html` + sanitização do
// snippet FTS reduzem o risco.

const STORAGE_KEY = 'copilot.dashboard.refresh_v1';

export function saveRefreshToken(token: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // localStorage pode estar desabilitado (modo privado antigo). Fail-silent:
    // o usuário precisará logar de novo na próxima sessão.
  }
}

export function readRefreshToken(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearRefreshToken(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
}
